import React from 'react';
import { benefits } from '../../../../constants'; 
import './CareerBenefits.css';

const CareerBenefits = () => {
    return (
        <section className='career-benefits'>
            <div className='benefits-container'>

                {/* --- LEWA STRONA (NAPIS) --- */}
                <div className='benefits-left-panel'>
                    <div className='sticky-content'>
                        <h2 className='vertical-title'>Ważne informacje</h2>
                        <p className='vertical-subtitle'>Korzyści współpracy</p>
                    </div>
                </div>

                {/* --- PRAWA STRONA (GRID Z ELEMENTAMI) --- */}
                <div className='benefits-grid'>
                    {benefits.map((benefit) => (
                        <div className="benefit-item" key={benefit.id}>
                            <div className='icon'>{benefit.icon}</div>
                            <div className='text'>
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default CareerBenefits;